module.exports = {"id":"s2-q2b","text":"Was the training conducted by a Registered Training Organisation or Tafe?","multiselect":false,"options":[{"id":"s2-q2b-a1","text":"Yes","next":"s2-q3","capability":0,"access":0,"focusarea":[0,4,0,0,0]},{"id":"s2-q2b-a2","text":"No","next":"s2-q2c","capability":1,"access":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q2b.json
// module id = 896
// module chunks = 41